import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SecurityUpdateGoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"security_update_good"}/>
}
